import urls from "global/constants/UrlConstants";
import { getCallParams, getFileCallParams, makeCall } from "utils/service";

export const contactsStatus = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_CONTACT_STATUS_TYPE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchAllContactsCount = async (
  filterType: string,
  searchText: string,
  category: number
) => {
  const body = {
    searchText: searchText,
    ownershipType: filterType,
    category: category,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_CONTACTS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchAllContacts = async (
  page: number,
  rowsPerPage: number,
  filterType: string,
  searchText: string,
  category: number
) => {
  try {
    const url = `${urls.GET_ALL_CONTACTS}/page/${page}/limit/${rowsPerPage}`;
    const body = {
      searchText: searchText,
      ownershipType: filterType,
      category: category,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchArchivedContactsCount = async (
  filterType: string,
  searchText: string,
  category: number
) => {
  const body = {
    searchText: searchText,
    ownershipType: filterType,
    category: category,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ARCHIVED_CONTACTS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchArchivedContacts = async (
  page: number,
  rowsPerPage: number,
  filterType: string,
  searchText: string,
  category: number
) => {
  try {
    const url = `${urls.GET_ARCHIVED_CONTACTS}/page/${page}/limit/${rowsPerPage}`;
    const body = {
      searchText: searchText,
      ownershipType: filterType,
      category: category,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getFileColumnType = async (file: any) => {
  try {
    const callParams = await getFileCallParams("POST", file);
    const response = await makeCall(urls.GET_COLUMN_TYPES, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const uploadContactGroups = async (file: any) => {
  try {
    const callParams = await getFileCallParams("POST", file);
    const response = await makeCall(urls.uploadContactGroup, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const exportContacts = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.EXPORT_CONTACTS, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAllGroups = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_ALL_GROUPS_SELECTION, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addSingleContact = async (groupId: number, contact: any) => {
  try {
    const url = `${urls.ADD_SINGLE_CONTACT}/${groupId}`;
    const callParams = await getCallParams("POST", contact);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addSingleGroup = async (group: any) => {
  try {
    const callParams = await getCallParams("POST", group);
    const response = await makeCall(urls.ADD_SINGLE_GROUP, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const softDeleteContact = async (ids: number[]) => {
  try {
    const callParams = await getCallParams("DELETE", ids);
    const response = await makeCall(urls.SOFT_DELETE_CONTACT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteArchiveContact = async (ids: number[]) => {
  try {
    const callParams = await getCallParams("DELETE", ids);
    const response = await makeCall(urls.DELETE_ARCHIVE_CONTACT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
